<template>
	<div class="searchPage">
		<!-- 搜索框 -->
		<van-sticky>
			<div class="header">
				<div class="searchBox">
					<!-- <div class="leftArr" @click="jumpSearchPage">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div> -->
					<!-- 左侧 -->
					<div class="search">
						<div class="selectBox">
							<div class="slide_down" @click.stop="toggle">
								<span>{{queryTitle}}</span>
								<div class="img_box">
									<img src="../../assets/img/select.png" alt=""/>
								</div>
							</div>
							<div class="searchValBox">
								<input type="text" v-model="inputVal" value="" :placeholder="keyword" @keyup.13 = "seachPageResult(inputVal)"/>
							</div>
							<!-- 排序方式 -->
							<ul v-show="selectItem" class="select_item">
								<li v-for="(item,index) in selectItemList" @click="query_select(item.sortVal,item.txt)" :class="soltIndex == item.sortVal ? 'activeQuery' : ''">
									<span>{{item.txt}}</span>
									<span class="queryArr" v-if="soltIndex == item.sortVal ? true : false"><img src="../../assets/img/query.png" alt=""></span>
								</li>
							</ul>
						</div>
					</div>
					<!-- 右侧 -->
					<div class="orderIcon" @click="jumpSearchQuery()">
						<img src="../../assets/img/order.png" alt="">
					</div>
				</div>
			</div>
		</van-sticky>
		<!-- <div class="soltBox">
			<div>
				<span v-model="queryTitle">{{queryTitle}}</span>
				<img src="../../assets/img/downarr.png" alt=""  @click="toggle"/>
				<ul v-show="selectItem" class="select_item">
					<li v-for="(item,index) in selectItemList" @click="query_select(item.sortVal,item.txt)" :class="soltIndex == item.sortVal ? 'activeQuery' : ''">
						<span>{{item.txt}}</span>
						<span class="queryArr" v-if="soltIndex == item.sortVal ? true : false"><img src="../../assets/img/query.png" alt=""></span>
					</li>
				</ul>
			</div>
			
		</div> -->
		<!-- 列表数据 -->
		<div v-if="bookInfoList.length != 0 ? true : false">
			<div class="blockBox">
				<div class="blockLeft" v-for="(item,index) in bookInfoList"  :key="index" @click="jumpBookinfo(item.book_id,item.cover_image)">
					<div class="book_Img">
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" />
					</div>
					<div class="blockBookInfo">
						<div class="bookName"><span>{{item.name}}</span>  <p><span>{{item.total_words}}字</span><span class="wanjie">{{item.progress_status}}</span></p></div>
						<div class="auther"><span>{{item.author}}</span></div>
						<p class="bookType">{{item.type_list + '-' + item.style_list + '-' + item.perspective_list}}</p>
						<div class="introduction" v-if="item.introduce != '' ? true : false">
							<p>{{item.introduce}}</p>
						</div>
						<!-- <div class="introduction" v-if="item.introduce == '' ? true : false">
							<p>&nbsp;</p>
						</div> -->
						<div class="book_button">
							<button v-for="itemName in item.lable_list">{{itemName.name}}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="bookInfoList.length == 0 ? true : false">
			暂无数据
		</div>
	</div>
</template>

<script>
	import qs from 'qs';
	export default {
		data() {
			return {
				soltIndex: 1, //排序选择
				inputVal:'', //搜索数据绑定
				searchPageTitle: '',
				selectTxt: '',
				
				selectItemSeach: false,
				selectItem: false,
				itemShow: false,
				urlRouter: '',
				// 检索页数据
				searchVal: '',   
				fwValue: '', 
				sexValue : '', 
				ycValue : '', 
				sjValue: '', 
				sdValue: '',   
				typeValue: '',   
				styleValue: '', 
				checkboxList: [],
				checkboxListStr: [],
				urlRouterHost: '',//搜索页面历史记录
				//搜索页
				type: 5,//类型type
				typeTxt: '',//类型type名称
				keyword: '请输入搜索',//keyword 关键词
				
				typeHost:'',
				typeTxtHost:'',
				keywordHost:'',
				bookInfoList: [],
				queryTitle:"按收藏数",
				selectItemList: [{
						txt: '按收藏数',
						sortVal: 1,
					},
					{
						txt: '按字数',
						sortVal: 2,
					},
					{
						txt: '按积分',
						sortVal: 3,
					},
					{
						txt: '按更新时间',
						sortVal: 4,
					},
					{
						txt: '按发表时间',
						sortVal: 5,
					},
					
				],
				historyList: [],
				name:'',
				content:'',
				cjsdpl: '',
				listId: '', //书单编辑id
			}
		},
		created(){
			this.urlRouter = this.$route.query.url;
			this.urlRouterHost = this.$route.query.urlHost;
			this.$axios.post(this.$api.search_book,{
				sort:this.soltIndex,
			}).then(res => {
				console.log(res.data.data)
				this.bookInfoList = res.data.data.list
			})
			if(this.urlRouter == 'searchPage' || this.urlRouterHost  == 'searchPage' ){
				console.log( this.$route.query.typeHost,this.$route.query.typeTxtHost,'this.$route.query.typeTxtHost')
					// 搜索页面
				this.type = this.$route.query.type  || this.$route.query.typeHost || '';
				this.typeTxt = this.$route.query.typeTxt || this.$route.query.typeTxtHost || '';
				this.keyword = this.$route.query.keyword || this.$route.query.keywordHost || ''; 
				console.log(this.typeTxt,'this.typeTxt')
				  let searchPageVal ={
				  	type:this.type,
				  	keyword: this.keyword
				  }
				this.$axios.post(`${this.$api.search_book} `,searchPageVal).then(res => {
					this.bookInfoList = res.data.data.list
				})
			}else if(this.urlRouter == 'searchResult'){
				//检索页面
				this.typeTxt = this.$route.query.typeTxt;
				this.searchVal = this.$route.query.searchVal || '';
				this.fwValue = this.$route.query.fwValue.fwValue;
				this.sexValue = this.$route.query.sexValue.sexValue;
				this.ycValue = this.$route.query.ycValue.ycValue;
				this.sjValue = this.$route.query.sjValue.sjValue;
				this.sdValue = this.$route.query.sdValue.sdValue;
				this.typeValue = this.$route.query.typeValue.typeValue;
				this.styleValue = this.$route.query.styleValue.styleValue;
				this.checkboxList = this.$route.query.checkboxList;
				for(var i = 0; i< this.checkboxList.length ; i++){
					console.log(this.checkboxList[i].labelValue,'str[i].labelValue')
					this.checkboxListStr.push(this.checkboxList[i].labelValue);
				}
				var arrStr = this.checkboxListStr.join();
				console.log(arrStr,'arrStr')
				let searchResultVal = {
					keyword: this.searchVal,
					fwValue:this.fwValue,
					sexValue:this.sexValue,
					ycValue:this.ycValue,
					sjValue:this.sjValue,
					sdValue:this.sdValue,
					typeValue:this.typeValue,
					styleValue:this.styleValue,
					labelValue: arrStr || '',
				}
				
				this.$axios.post(`${this.$api.search_book}?${qs.stringify(searchResultVal)}`).then(res => {
					console.log(res.data.data)
					this.bookInfoList = res.data.data.list
				})
			}
			// else if(this.typeTxtHost != ''){
				// 搜索历史页面
				// this.type = this.$route.query.typeHost;
				// this.typeTxtHost = this.$route.query.typeTxtHost;
				// this.keywordHost = this.$route.query.keywordHost || ''; 
				// console.log(this.typeHost,this.typeTxtHost,this.keywordHost,'----000---')
				//   let searchPageVal2 ={
				//   	type:this.type,
				//   	keyword: this.keywordHost
				//   }
				// this.$axios.post(`${this.$api.search_book} `,searchPageVal2).then(res => {
				// 	this.bookInfoList = res.data.data.list
				// })
			// }
			
			this.name = this.$route.query.name
			this.content = this.$route.query.content;
			this.cjsdpl = this.$route.query.comment;
			this.listId = this.$route.query.listId;
		},
		methods: {
			toggle() {
				this.selectItem = !this.selectItem
			},

			jumpSearchQuery(){
				this.$router.push({path: '/searchQuery'})
			},
			jumpSearchPage(){
				this.$router.push({path: '/cjsd'})
			},
			seachPageResult(val){

				this.inputVal = val;
				this.$axios.post(this.$api.search_book,{
					keyword:this.inputVal,
					type: this.type,
				}).then(res => {
					console.log(res.data.data)
					this.bookInfoList = res.data.data.list
				})
				
			},
			query_select(index, txt) {
				console.log(index)
				this.soltIndex = index;
				this.queryTitle = txt;
				this.selectItem = !this.selectItem;
				this.$axios.post(this.$api.search_book,{
					sort:this.soltIndex,
				}).then(res => {
					console.log(res.data.data)
					this.bookInfoList = res.data.data.list
				})
			},
			//存储当前记录
			 saveHistory(name, number) {
					number = this.type;
					name = this.keyword;
			        let temp = []
			        if (localStorage.getItem('searchHistory')) {
			          temp = JSON.parse(localStorage.getItem('searchHistory'))
			          if (temp.length >= 5) temp.pop()
			          let sameIndex = temp.findIndex((item, index) => {
			            return item.number === number
			          })
			          if (sameIndex >= 0) temp.splice(sameIndex, 1)
			        }
			        temp.unshift({ number, name})
					console.log(temp,'temp')
			        localStorage.setItem('searchHistory', JSON.stringify(temp))
			        this.historyList = JSON.parse(localStorage.getItem('searchHistory'))
					console.log(this.historyList,'historyList')
			},
			back() {
				this.$router.go(-1)
			},
			jumpBookinfo(val,img) {
				console.log(val, 'val');
				this.$router.push({
					path: '/cjsd',
					query: {
						book_id: val,
						book_img:img,
						name:this.name,
						content:this.content,
						comment:this.cjsdpl,
						listId: this.listId,
					}
				})
			},
		}
	};
</script>

<style scoped lang="less">
	* {
		margin: 0;
		padding: 0;
	}

	.searchPage {
		height: 100vh;
		width: 100vw;
		overflow-y: scroll;
		background-color: #f0f0f0;
		color: #000;
	.header {
			display: flex;
			height: 160px;
			// background-color: #ff4081;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.searchBox {
				position: relative;
				margin-top: 70px;
				width: 100%;
				.leftArr{
					img{
						position: absolute;
						top: 50%;
						left: 0px;
						transform: translateY(-50%);
						width: 50px;
						height: 50px;
					}
				}
				// padding: 0 40px;
				.search {
					background-color: #fff;
					border-radius: 50px;
					width: 80vw;
					position: absolute;
					top: 50%;
					left: 60px;
					transform: translateY(-50%);

					.selectBox {
						position: relative;
						width: 80vw;
						height: 60px;
						display: flex;
						background-color: rgba(0,0,0,.05);
						border-radius: 60px;
						.select_item {
							width: 160px;
							z-index: 9;
							line-height: 56px;
							padding: 0 15px;
							box-shadow: 0 1px 4px 0 rgba(0,0,0,.3);/*no*/
							position: absolute;
							left: 30px;
							top: 60px;
							background-color: #fff;
							li {
								color: #9A9A9A;
								display: flex;
								align-items: center;
								justify-content: space-between;
								img{
									width: 30px;
								}
							}
						}
						.searchValBox{
							flex: 1;
							line-height:60px;
							input{
								width: 93%;
								padding-left: 20px;
								background-color: transparent;
							}
						}

						.slide_down {
							width: 160px;
							display: flex;
							align-items: center;
							justify-content: space-between;
							height: 60px;
							padding-left: 40px;

							span {
								color: #919191;
							}

							.img_box {
								width: 40px;
								height: 40px;

								img {
									width: 100%;
									display: block;
								}
							}
						}

						.activeQuery {
							color: #ff4081 !important;
							border-bottom: 4px solid #f0f0f0;
							/*no*/
						}

						.solt {
							font-size: 32px;
							/*px*/
							position: absolute;
							top: 50%;
							left: 30px;
							transform: translateY(-50%);
							color: #cccccc;
						}
					}
				}

				.orderIcon {
					position: absolute;
					top: 50%;
					right: 20px;
					transform: translateY(-50%);
					height: 60px;
					line-height: 60px;

					img {
						position: absolute;
						top: 50%;
						right: 5px;
						transform: translateY(-50%);
						width: 42px;
						height: 42px;
					}
				}
			}

		}
		//排序方式
		.soltBox {
			background-color: #fff;
			
			padding: 0 16px;

			div {
				line-height: 80px;
				padding-top: 10px;
				// position: relative;
				span {
					font-size: 32px;
					/*px*/
				}

				img {
					margin-left: 10px;
					width: 30px;
				}
				
				// 下拉框css
				ul.select_item {
					position: absolute;
					top: 19%;
					left: 10%;
					background-color: #fff;
					z-index: 100;
					border-radius: 10px;
					-webkit-box-shadow: 0px 1px 4px 0px rgba(0,0,0,.3);/*no*/
					-moz-box-shadow:0px 1px 4px 0px rgba(0,0,0,.3);/*no*/
					box-shadow: 0px 1px 4px 0px rgba(0,0,0,.3);/*no*/
					li {
						padding: 0 20px;
						line-height: 60px;
						border-bottom: 1px solid #f0f0f0;/*no*/
				
						span {
							font-size: 28px;
							/*px*/
						}
				
						img {
							margin-left: 10px;
							width: 20px;
							height: 20px;
						}
					}
				
					.activeQuery {
						color: #ff4081;
						border-bottom: 4px solid #f0f0f0;/*no*/
					}
				}
			}
		
		}

		//列表数据
		.blockBox {
			overflow: hidden;
			// position: relative;
			background-color: #fff;
			padding: 0px 16px;
			.blockLeft {
				display: flex;
				background-color: #fff;
				padding: 20px 0px;
				padding-bottom: 20px;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.book_Img {
					// width: 138px;
					height: 240px;

					img {
						height: 240px;
						display: block;
						float: left;
						-webkit-box-shadow: 0 0 4px 0 rgba(0,0,0,.3);/*no*/
						-moz-box-shadow: 0 0 4px 0 rgba(0,0,0,.3);/*no*/
						box-shadow: 0 0 4px 0 rgba(0,0,0,.3);/*no*/
					}
				}

				.blockBookInfo {
					margin-left: 10px;
					flex: 1;
					font-size: 26px;
					/*px*/
					line-height: 30px;

					.auther {
						color: #676767;
						font-size: 28px;/*px*/
					}

					.bookName {
						// line-height: 40px;
						padding-bottom: 20px;
						font-size: 30px;/*px*/
						font-weight: 600;
						color: #000000;
						display: flex;
						justify-content: space-between;
						>span{
							display:block;
							width: 30vw;
							height: 32px;
							line-height: 32px;
							overflow: hidden;
							-webkit-line-clamp: 1;
							line-clamp: 1;
						}
						p {
							display: inline-block;
							font-weight: 400;
							span {
								margin-left: 8px;
								color: #4c4c4c;
								font-size: 26px;
								/*px*/
							}

							// .wanjie {
							// 	color: #ff0000;
							// }

							// .txtGreen {
							// 	color: #5ca615;
							// }
						}
					}

					.bookType,
					.introduction {
						padding-top: 20px;
						color: #a3a3a3;
					}

					.introduction {
						width: 60vw;
						padding-top: 15px;

						p {
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}
					}

					.book_button {
						margin-top: 25px;

						button {
							outline: none;
							border: 0;
							border: 1px solid #fec6d5;/*no*/
							border-radius: 28px;
							padding: 0px 20px;
							display: inline-block;
							line-height: 40px;
							background-color: #fff8fa;
							color: #fa7298;
							margin-right: 20px;
							font-size: 26px;/*px*/
							margin-bottom: 20px;
						}

						.active {
							background-color: #fa7298;
							color: #ffffff;
						}
					}
				}
			}

		}
	}
</style>
